var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursorClick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2450_7336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 2.91667V1.66667M4.21705 4.21722L3.33317 3.33334M4.21705 10.8333L3.33317 11.7172M10.8332 4.21722L11.7171 3.33334M2.9165 7.5H1.6665M13.2202 13.4913L11.1438 17.3475C10.9066 17.7881 10.788 18.0083 10.6453 18.0641C10.5214 18.1124 10.3819 18.0987 10.2698 18.0273C10.1406 17.945 10.067 17.7059 9.91968 17.2277L7.03749 7.87105C6.91717 7.48043 6.85701 7.28512 6.90542 7.1532C6.94758 7.0383 7.03813 6.94775 7.15303 6.90559C7.28495 6.85718 7.48026 6.91734 7.87088 7.03767L17.2275 9.91988C17.7057 10.0672 17.9448 10.1408 18.0271 10.27C18.0985 10.3821 18.1122 10.5216 18.0639 10.6455C18.0081 10.7882 17.7879 10.9068 17.3473 11.144L13.4911 13.2204C13.4257 13.2557 13.393 13.2733 13.3643 13.2959C13.3389 13.316 13.3159 13.339 13.2958 13.3645C13.2731 13.3931 13.2555 13.4259 13.2202 13.4913Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2450_7336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClick);
export default __webpack_public_path__ + "static/media/cursor-click.e2cd7f6dec437b536ca745b0bb1e4adc.svg";
export { ForwardRef as ReactComponent };